var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 45,
    viewBox: "0 0 287 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mii2dwd8ob",
    x1: "97.446%",
    x2: "-2.326%",
    y1: "49.945%",
    y2: "50.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ie2qhijy0e",
    x1: "97.89%",
    x2: ".336%",
    y1: "44.46%",
    y2: "51.092%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8f34dlxv7h",
    x1: "98.681%",
    x2: "3.244%",
    y1: "36.621%",
    y2: "57.395%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tci0xnj1jk",
    x1: "98.977%",
    x2: "7.278%",
    y1: "22.665%",
    y2: "68.801%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hapk8jpq6n",
    x1: "97.421%",
    x2: "9.787%",
    y1: "95.912%",
    y2: "9.29%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2iaqsk62rq",
    x1: "97.249%",
    x2: "5.945%",
    y1: "75.899%",
    y2: "30.564%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ky7w1k9dyt",
    x1: "97.1%",
    x2: "2.146%",
    y1: "63.262%",
    y2: "42.347%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "64lqpdhy6w",
    x1: "97.044%",
    x2: "-.013%",
    y1: "55.623%",
    y2: "48.877%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lkt04uir0z",
    x1: "-2.599%",
    x2: "97.303%",
    y1: "50.083%",
    y2: "50.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rz66z0e63C",
    x1: "-1.955%",
    x2: "95.225%",
    y1: "55.995%",
    y2: "49.209%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k3wuqtuj5F",
    x1: "-1.108%",
    x2: "93.231%",
    y1: "64.882%",
    y2: "43.382%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oy1b85g64I",
    x1: "-.828%",
    x2: "89.944%",
    y1: "78.283%",
    y2: "32.604%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ov2xxv4aoL",
    x1: ".982%",
    x2: "86.208%",
    y1: "100.71%",
    y2: "13.258%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "inef3qgt8O",
    x1: "-2.649%",
    x2: "88.288%",
    y1: "20.486%",
    y2: "66.541%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "905y841unR",
    x1: "-2.533%",
    x2: "91.739%",
    y1: "34.765%",
    y2: "56.274%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0revx91anU",
    x1: "-2.764%",
    x2: "94.606%",
    y1: "44.037%",
    y2: "50.747%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fwayl73rrX",
    x1: "23.639%",
    x2: "67.731%",
    y1: "100.184%",
    y2: "8.301%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ncw8mefzxaa",
    x1: "36.384%",
    x2: "56.952%",
    y1: "99.087%",
    y2: "4.363%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b6qsc5zwsad",
    x1: "44.533%",
    x2: "51.014%",
    y1: "98.563%",
    y2: "1.086%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1okav9l89ag",
    x1: "50.06%",
    x2: "49.998%",
    y1: "98.038%",
    y2: "-1.967%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f72qyxywzaj",
    x1: "55.246%",
    x2: "48.929%",
    y1: "97.668%",
    y2: ".207%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f7vgfgarsam",
    x1: "62.966%",
    x2: "42.851%",
    y1: "97.403%",
    y2: "3.403%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vpcz9mmpcap",
    x1: "75.034%",
    x2: "31.008%",
    y1: "97.633%",
    y2: "5.685%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "4y10vc02xa",
    d: "M0 1.307c0 .378.013.752.029 1.123l8.23-1.186v-.038L.034.02C.011.447 0 .876 0 1.307"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fnhczqudhd",
    d: "M.26.455c.114.803.268 1.593.458 2.37L8.58.036 8.572.001.26.455z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ns5gv6ktig",
    d: "M.688 2.236c.27.763.574 1.51.913 2.236L8.785.186 8.77.15.688 2.236z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hsjiwaryjj",
    d: "M.55 3.699c.41.694.854 1.367 1.33 2.015L8.104.092l-.02-.033L.548 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2540uoq78m",
    d: "M.582 2.29L7.19 7.28l.026-.025L2.265.604C1.679 1.139 1.116 1.702.582 2.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vyid0lwenp",
    d: "M.622 2.492l7.463 3.6.019-.03L1.95.504c-.472.64-.916 1.303-1.329 1.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f0eoen51fs",
    d: "M.004 2.449L8.035 4.52l.014-.036L.924.235c-.34.72-.648 1.46-.92 2.214"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0clmbrz3mv",
    d: "M.28 2.737l8.292.453.006-.036L.752.38C.56 1.15.4 1.938.28 2.737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iign6flziy",
    d: "M.03 1.207v.038L8.265 2.43c.017-.371.028-.745.028-1.123 0-.43-.011-.86-.032-1.285L.03 1.207z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pimupjedwB",
    d: "M.446 3.156l.006.036 8.295-.454c-.12-.8-.279-1.587-.472-2.36L.446 3.157z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o3dfe08bzE",
    d: "M.241 4.485l.013.036L8.29 2.45c-.271-.756-.58-1.496-.92-2.217L.24 4.485z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9k7ynzu6rH",
    d: "M.185 6.063l.022.032L7.668 2.49c-.41-.685-.855-1.348-1.328-1.989L.185 6.063z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ni1b8ze85K",
    d: "M.34 7.255l.027.026L6.974 2.29C6.44 1.7 5.879 1.138 5.29.603L.34 7.255z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dymykt1zfN",
    d: "M.184.092L6.41 5.716c.477-.649.92-1.321 1.333-2.017L.205.06.184.092z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lo2dojyzdQ",
    d: "M.239.186l7.187 4.289c.339-.728.644-1.475.914-2.237L.254.15.24.186z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jftxd993tT",
    d: "M.445.039l7.864 2.785c.19-.776.343-1.565.46-2.368L.451 0 .445.039z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifdtctgxbW",
    d: "M.049 8.157l.03.02 5.506-6.184C4.95 1.519 4.29 1.076 3.612.667L.049 8.157z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2sjda1ydgZ",
    d: "M.138 8.107l.035.014 4.2-7.144C3.66.64 2.929.334 2.183.066L.137 8.106z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fgv7jijwgac",
    d: "M.724 8.648l.036.007L3.493.828C2.733.638 1.958.483 1.17.365L.724 8.648z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jjkf7uag9af",
    d: "M1.204.094C.808.094.413.106.02.124l1.165 8.209h.038L2.388.123C1.996.107 1.601.095 1.204.095z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jqyamrgwbai",
    d: "M.385.829l2.732 7.826.038-.007L2.707.365C1.921.483 1.146.64.385.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3k0ngqchual",
    d: "M.24.979L4.441 8.12l.034-.014L2.432.067C1.684.336.954.64.24.979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hf6bke7viao",
    d: "M.5 1.993l5.507 6.185.03-.022L2.474.667C1.794 1.08 1.136 1.52.5 1.993"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(0 5.926) translate(0 17.778)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e1mauqsiac",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4y10vc02xa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#mii2dwd8ob)",
    d: "M0 1.307c0 .378.013.752.029 1.123l8.23-1.186v-.038L.034.02C.011.447 0 .876 0 1.307",
    mask: "url(#e1mauqsiac)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(0 5.926) translate(0 22.222)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6hpkknporf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fnhczqudhd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ie2qhijy0e)",
    d: "M.26.455c.114.803.268 1.593.458 2.37L8.58.036 8.572.001.26.455z",
    mask: "url(#6hpkknporf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(0 5.926) translate(.735 25.185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pyjuw69cwi",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ns5gv6ktig"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#8f34dlxv7h)",
    d: "M.688 2.236c.27.763.574 1.51.913 2.236L8.785.186 8.77.15.688 2.236z",
    mask: "url(#pyjuw69cwi)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(0 5.926) translate(2.941 28.148)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fyvvi1gcwl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hsjiwaryjj"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tci0xnj1jk)",
    d: "M.55 3.699c.41.694.854 1.367 1.33 2.015L8.104.092l-.02-.033L.548 3.7z",
    mask: "url(#fyvvi1gcwl)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(0 5.926) translate(5.882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y84cj5221o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2540uoq78m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hapk8jpq6n)",
    d: "M.582 2.29L7.19 7.28l.026-.025L2.265.604C1.679 1.139 1.116 1.702.582 2.29",
    mask: "url(#y84cj5221o)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(0 5.926) translate(2.941 3.704)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3fst591gcr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vyid0lwenp"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2iaqsk62rq)",
    d: "M.622 2.492l7.463 3.6.019-.03L1.95.504c-.472.64-.916 1.303-1.329 1.988",
    mask: "url(#3fst591gcr)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(0 5.926) translate(1.47 8.148)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3ztzmdim2u",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f0eoen51fs"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ky7w1k9dyt)",
    d: "M.004 2.449L8.035 4.52l.014-.036L.924.235c-.34.72-.648 1.46-.92 2.214",
    mask: "url(#3ztzmdim2u)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(0 5.926) translate(0 12.593)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d6g1lnpaix",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0clmbrz3mv"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#64lqpdhy6w)",
    d: "M.28 2.737l8.292.453.006-.036L.752.38C.56 1.15.4 1.938.28 2.737",
    mask: "url(#d6g1lnpaix)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(36.03 5.926) translate(5.147 17.778)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qus4wet9bA",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iign6flziy"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lkt04uir0z)",
    d: "M.03 1.207v.038L8.265 2.43c.017-.371.028-.745.028-1.123 0-.43-.011-.86-.032-1.285L.03 1.207z",
    mask: "url(#qus4wet9bA)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(36.03 5.926) translate(4.412 12.593)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sy29k7x0gD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pimupjedwB"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#rz66z0e63C)",
    d: "M.446 3.156l.006.036 8.295-.454c-.12-.8-.279-1.587-.472-2.36L.446 3.157z",
    mask: "url(#sy29k7x0gD)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(36.03 5.926) translate(3.676 8.148)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9uqbljpbcG",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o3dfe08bzE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k3wuqtuj5F)",
    d: "M.241 4.485l.013.036L8.29 2.45c-.271-.756-.58-1.496-.92-2.217L.24 4.485z",
    mask: "url(#9uqbljpbcG)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(36.03 5.926) translate(2.206 3.704)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s8cvona13J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9k7ynzu6rH"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#oy1b85g64I)",
    d: "M.185 6.063l.022.032L7.668 2.49c-.41-.685-.855-1.348-1.328-1.989L.185 6.063z",
    mask: "url(#s8cvona13J)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(36.03 5.926)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lmlrf3fl6M",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ni1b8ze85K"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ov2xxv4aoL)",
    d: "M.34 7.255l.027.026L6.974 2.29C6.44 1.7 5.879 1.138 5.29.603L.34 7.255z",
    mask: "url(#lmlrf3fl6M)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(36.03 5.926) translate(2.206 28.148)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6x250wkeuP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dymykt1zfN"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#inef3qgt8O)",
    d: "M.184.092L6.41 5.716c.477-.649.92-1.321 1.333-2.017L.205.06.184.092z",
    mask: "url(#6x250wkeuP)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(36.03 5.926) translate(3.676 25.185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sqyffxnjnS",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lo2dojyzdQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#905y841unR)",
    d: "M.239.186l7.187 4.289c.339-.728.644-1.475.914-2.237L.254.15.24.186z",
    mask: "url(#sqyffxnjnS)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(36.03 5.926) translate(4.412 22.222)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vcp6ikjk4V",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jftxd993tT"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#0revx91anU)",
    d: "M.445.039l7.864 2.785c.19-.776.343-1.565.46-2.368L.451 0 .445.039z",
    mask: "url(#vcp6ikjk4V)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(9.559) translate(24.265 2.963)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zc7z1s6pvY",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ifdtctgxbW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fwayl73rrX)",
    d: "M.049 8.157l.03.02 5.506-6.184C4.95 1.519 4.29 1.076 3.612.667L.049 8.157z",
    mask: "url(#zc7z1s6pvY)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(9.559) translate(21.324 1.481)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "24kc9h69rab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2sjda1ydgZ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ncw8mefzxaa)",
    d: "M.138 8.107l.035.014 4.2-7.144C3.66.64 2.929.334 2.183.066L.137 8.106z",
    mask: "url(#24kc9h69rab)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(9.559) translate(17.647)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "74xokzrvvae",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fgv7jijwgac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b6qsc5zwsad)",
    d: "M.724 8.648l.036.007L3.493.828C2.733.638 1.958.483 1.17.365L.724 8.648z",
    mask: "url(#74xokzrvvae)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(9.559) translate(13.97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lbym62ze8ah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jjkf7uag9af"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#1okav9l89ag)",
    d: "M1.204.094C.808.094.413.106.02.124l1.165 8.209h.038L2.388.123C1.996.107 1.601.095 1.204.095z",
    mask: "url(#lbym62ze8ah)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(9.559) translate(8.824)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uoinr1rqbak",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jqyamrgwbai"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f72qyxywzaj)",
    d: "M.385.829l2.732 7.826.038-.007L2.707.365C1.921.483 1.146.64.385.83",
    mask: "url(#uoinr1rqbak)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(9.559) translate(4.412 1.481)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2a63n91zban",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3k0ngqchual"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f7vgfgarsam)",
    d: "M.24.979L4.441 8.12l.034-.014L2.432.067C1.684.336.954.64.24.979",
    mask: "url(#2a63n91zban)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44) translate(0 .127) translate(9.559) translate(0 2.963)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bd1r9y6a9aq",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hf6bke7viao"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vpcz9mmpcap)",
    d: "M.5 1.993l5.507 6.185.03-.022L2.474.667C1.794 1.08 1.136 1.52.5 1.993",
    mask: "url(#bd1r9y6a9aq)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M26.375 45.185c.47-1.719 2.563-1.585 2.563-1.585h7.149V29.126H38V45.26h-8.592s-1.59-.149-1.78 1.867h-6.26c-.19-2.016-1.779-1.867-1.779-1.867H11V29.126h1.91V43.6h7.151s2.088-.134 2.56 1.585h3.754z",
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M28.712 17.93s-.508 1.528-2.846 3.403c0 0-3.178 2.377-1.08 4.725 0 0 2.308 1.994 5.124-1.145 0 0 2.907-3.637-1.198-6.982zm-4.205 24.115c.743-1.235 2.466-1.144 2.466-1.144h6.084V28.258h-5.783s-1.468.028-1.499 1.202h-2.547c-.03-1.174-1.497-1.202-1.497-1.202h-5.782v12.643h6.083s1.721-.09 2.475 1.144zm.341-22.294c5.153-4.137-.39-8.273-.39-8.273s.42 3.295-3.476 6.073c-3.086 2.2-3.416 7.833 1.947 9.093-2.518-3.49 1.92-6.893 1.92-6.893zm5.43 6.957L35 26.703V42.63h-7.55s-1.617-.06-1.59 1.496h-2.722c.031-1.557-1.588-1.496-1.588-1.496H14V26.703h5.633s-2.458-.853-2.847-4.636c-.388-3.784 2.966-5.807 2.966-5.807 3.112-2.426 2.982-5.624 2.83-6.747-.056-.455.229-.382.229-.382 6.11 1.028 6.316 6.891 6.316 6.891s3.991 1.999 3.626 6.222c-.247 2.883-1.764 4.062-2.475 4.463v.001z",
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M21 32.127L19.872 32.127 19.059 34.342 19.059 32.127 18 32.127 18 37.127 19.059 37.127 19.059 34.911 19.872 37.127 21 37.127 19.973 34.627zM22.85 37.127L21.992 34.368 21.979 34.368 22.098 37.127 21 37.127 21 32.127 22.155 32.127 23.008 34.888 23.027 34.888 22.902 32.127 24 32.127 24 37.127zM25 35.663v-3.536h1.117v3.685c0 .29.128.435.385.435.252 0 .378-.155.378-.468v-3.653H28v3.537c0 .977-.502 1.464-1.505 1.464-.997 0-1.495-.487-1.495-1.464M32 37.127L29 37.127 29 32.127 32 32.127 32 33.125 30.291 33.125 30.291 34.124 31.893 34.124 31.893 35.123 30.291 35.123 30.291 36.129 32 36.129zM71.448 24.34V10.472h2.142v5.742H76v1.914h-2.41v6.212h-2.142zm-6.426-4.094c1.03 0 1.875-.611 1.875-1.73 0-1.12-.844-1.73-1.875-1.73H62.51c-1.03 0-1.874.61-1.874 1.73 0 1.119.844 1.73 1.874 1.73h2.512zm-4.9 7.88v-4.785h2.142v2.913h11.759v1.872H60.12zm2.203-6.088c-2.307 0-3.83-1.385-3.83-3.522 0-2.138 1.523-3.523 3.83-3.523h2.883c2.307 0 3.83 1.385 3.83 3.523 0 2.137-1.523 3.522-3.83 3.522h-2.883zM58 13.954v-1.873h4.696v-1.954h2.141v1.954h4.696v1.873H58zM91.053 29.127L91.053 24.513 78.462 24.513 78.462 22.618 84.893 22.618 84.893 19.941 77 19.941 77 18.046 90.991 18.046 90.991 12.979 78.629 12.979 78.629 11.127 93.162 11.127 93.162 18.046 95 18.046 95 19.941 87.106 19.941 87.106 22.618 93.225 22.618 93.225 29.127zM108.907 22.33v-9.326H96.712v-1.877h14.367V22.33h-2.172zM95 27.127v-1.878h4.239v-7.224h2.088v7.224h3.007v-7.224h2.089v7.224H113v1.878H95zM128.36 25.41v-1.473h-4.646v-1.828h4.646V11.126h2.196v14.285h-2.196zm-7.855-12.416c-2.324 0-3.485.748-3.485 1.641 0 .872 1.161 1.62 3.485 1.62 2.322 0 3.484-.748 3.484-1.62 0-.893-1.162-1.64-3.484-1.64zm-4.393 16.133v-5.19h2.197v3.383H131v1.806h-14.888zm4.393-11.025c-3.802 0-5.68-1.474-5.68-3.467s1.878-3.488 5.68-3.488c3.8 0 5.68 1.495 5.68 3.488 0 1.993-1.88 3.467-5.68 3.467zm.718 2.74v3.198h-2.197v-3.197H114v-1.91h12.882v1.91h-5.66zM147.9 29.127v-9.391h-2.425v8.876h-2.08v-17.28h2.08V17.8h2.424v-6.674H150v18h-2.1zM134 25.933V12.032h7.637v1.895H136.1V24.04h6.08v1.894H134zM165.448 21.623V10.469h2.142v4.65H170v1.893h-2.41v4.61h-2.142zm-6.426-2.315c1.03 0 1.875-.363 1.875-1.45s-.844-1.45-1.875-1.45h-2.512c-1.03 0-1.874.363-1.874 1.45s.844 1.45 1.874 1.45h2.512zm6.426 8.819v-4.068h-11.533v-1.752h13.675v5.82h-2.142zm-9.123-7.048c-2.307 0-3.83-1.127-3.83-3.221 0-2.094 1.523-3.222 3.83-3.222h2.883c2.307 0 3.83 1.128 3.83 3.222 0 2.094-1.523 3.22-3.83 3.22h-2.883zM152 13.689v-1.85h4.696v-1.713h2.141v1.712h4.655v1.852H152zM183.907 22.33v-9.326h-12.195v-1.877h14.367V22.33h-2.172zM170 27.127v-1.878h4.239v-7.224h2.088v7.224h3.007v-7.224h2.089v7.224H188v1.878h-18zM207.907 22.33v-9.326h-12.195v-1.877h14.367V22.33h-2.172zM194 27.127v-1.878h4.239v-7.224h2.088v7.224h3.007v-7.224h2.089v7.224H212v1.878h-18zM219.577 23.195h4.845V21.19h-4.845v2.005zm-.96-10.268c-1.525 0-2.213.715-2.213 1.717 0 1.002.688 1.739 2.213 1.739h6.787c1.524 0 2.192-.737 2.192-1.739 0-1.002-.668-1.717-2.192-1.717h-6.787zm-.188 5.256c-2.547 0-4.198-1.493-4.198-3.539 0-2.046 1.65-3.518 4.198-3.518h7.163c2.547 0 4.176 1.472 4.176 3.518s-1.63 3.539-4.176 3.539h-7.163zm8.624 10.944v-4.051h-12.591v-1.881h2.923V21.19H213v-1.882h18v1.882h-4.385v2.005h2.61v5.931h-2.172zM245.325 21.675V11.126h2.2v4.003H250v1.928h-2.475v4.618h-2.2zM234.2 18.782h5.88v-2.77h-5.88v2.77zm11.125 10.345v-4.66h-11.844v-1.889h14.044v6.549h-2.2zM232 20.67v-9.277h2.2v2.77h5.88v-2.77h2.199v9.277H232zM254.01 15.025h9.98v-2.102h-9.98v2.102zm-2.172 1.795h14.325v-5.694h-14.325v5.694zm-.063 12.306V24.27h12.278v-1.306h-12.3v-1.796h6.14V19.8H250v-1.836h18V19.8h-7.894v1.367h6.119v4.857h-12.278v1.306h12.696v1.797h-14.868zM282.622 24.87V11.127h2.128v5.087H287v1.951h-2.25v6.707h-2.128zm-11.25 4.256V23.48h2.128v3.737h11.679v1.91h-13.807zm6.791-10.234v-5.627h-8.386v-1.868h10.513v7.495h-2.127zM269 22.026v-1.91h4.132v-4.11h2.168v4.11h6.504v1.91H269zM59 33.127L60.435 33.127 60.435 37.382 60.472 37.382 63.935 33.127 65.53 33.127 62.711 36.6 66 42.127 64.404 42.127 61.832 37.724 60.435 39.412 60.435 42.127 59 42.127zM67 33.127h1.543l3.162 5.282.999 1.908h.064c-.078-.93-.194-2.018-.194-2.997v-4.194H74v9h-1.543l-3.162-5.306-.999-1.884h-.065c.078.93.194 1.969.194 2.947v4.243H67v-9zM76 38.173v-5.047h1.485v5.144c0 1.994.844 2.643 2.021 2.643 1.19 0 2.06-.649 2.06-2.643v-5.144H83v5.047c0 2.884-1.407 3.953-3.494 3.953-2.086 0-3.506-1.07-3.506-3.953M85 33.127L89.876 33.127 89.876 34.313 86.301 34.313 86.301 36.82 89.327 36.82 89.327 38.018 86.301 38.018 86.301 40.928 90 40.928 90 42.127 85 42.127zM95 33.127L99.876 33.127 99.876 34.313 96.301 34.313 96.301 36.82 99.327 36.82 99.327 38.018 96.301 38.018 96.301 40.928 100 40.928 100 42.127 95 42.127zM105.603 40.127v-3.322c-.498-.456-.971-.616-1.47-.616-.934 0-1.688.9-1.688 2.37 0 1.543.596 2.395 1.64 2.395.559 0 1.033-.26 1.518-.827M101 38.583c0-2.21 1.372-3.58 2.866-3.58.766 0 1.252.296 1.799.766l-.062-1.124v-2.519H107v9.84h-1.142l-.121-.765h-.036c-.499.519-1.19.925-1.944.925-1.676 0-2.757-1.296-2.757-3.543M110 39.428v-4.301h1.267v4.128c0 1.18.297 1.64 1.013 1.64.562 0 .948-.297 1.453-1.019v-4.75H115v6.839h-1.035l-.1-1.032h-.032c-.55.721-1.146 1.194-1.982 1.194-1.29 0-1.851-.957-1.851-2.699M117 38.645c0-2.233 1.44-3.519 3.083-3.519.794 0 1.373.34 1.826.765l-.646.91c-.34-.328-.692-.522-1.123-.522-1.042 0-1.79.946-1.79 2.366 0 1.407.714 2.342 1.756 2.342.522 0 .987-.268 1.36-.608l.534.923c-.568.546-1.304.825-2.018.825-1.69 0-2.982-1.274-2.982-3.482M126.705 40.246v-1.638c-1.835.242-2.455.74-2.455 1.492 0 .656.417.923.969.923.54 0 .979-.28 1.486-.777M123 40.198c0-1.432 1.126-2.172 3.705-2.476-.012-.776-.27-1.455-1.182-1.455-.653 0-1.262.314-1.791.68l-.484-.948c.642-.436 1.509-.873 2.5-.873 1.543 0 2.252 1.056 2.252 2.827v4.016h-1.058l-.113-.764h-.034c-.563.522-1.228.922-1.97.922-1.07 0-1.825-.753-1.825-1.93M129.901 39.698v-3.5H129v-1.083l.958-.075.146-1.913h1.093v1.913h1.61v1.158h-1.61v3.512c0 .83.26 1.259.901 1.259.214 0 .485-.076.665-.165l.237 1.071c-.35.126-.766.252-1.217.252-1.398 0-1.882-.97-1.882-2.43M134.218 42.127h1.55v-6.971h-1.55v6.97zm-.218-9.14c0-.519.422-.86.993-.86s1.007.341 1.007.86c0 .508-.436.863-1.007.863s-.993-.355-.993-.862zM142.633 38.645c0-1.42-.626-2.366-1.633-2.366-.996 0-1.622.946-1.622 2.366 0 1.407.626 2.342 1.622 2.342 1.007 0 1.633-.935 1.633-2.342m-4.633 0c0-2.233 1.425-3.519 3-3.519s3 1.286 3 3.519c0 2.208-1.425 3.481-3 3.481s-3-1.273-3-3.481M145 35.3h1.234l.118.943h.04c.67-.609 1.404-1.117 2.39-1.117 1.535 0 2.218.968 2.218 2.705v4.295h-1.51v-4.12c0-1.18-.367-1.652-1.22-1.652-.67 0-1.13.323-1.773.932v4.84H145V35.3zM156.705 40.246v-1.638c-1.835.242-2.455.74-2.455 1.492 0 .656.417.923.969.923.54 0 .979-.28 1.486-.777M153 40.198c0-1.432 1.126-2.172 3.705-2.476-.012-.776-.27-1.455-1.182-1.455-.653 0-1.262.314-1.791.68l-.484-.948c.642-.436 1.509-.873 2.5-.873 1.543 0 2.252 1.056 2.252 2.827v4.016h-1.058l-.113-.764h-.034c-.563.522-1.228.922-1.97.922-1.07 0-1.825-.753-1.825-1.93M160 40.373v-8.246h1.296v8.32c0 .383.158.519.318.519.057 0 .102 0 .216-.025l.17 1.074c-.159.062-.386.111-.704.111-.944 0-1.296-.654-1.296-1.753M166 33.127h1.67l1.696 4.548c.213.599.402 1.211.615 1.823h.062c.214-.612.39-1.224.603-1.823l1.67-4.548H174v9h-1.357v-4.452c0-.806.113-1.968.189-2.788h-.05l-.742 2.08-1.607 4.291h-.905l-1.62-4.292-.728-2.079h-.05c.063.82.176 1.982.176 2.788v4.452H166v-9zM176 39.428v-4.301h1.267v4.128c0 1.18.297 1.64 1.013 1.64.562 0 .948-.297 1.453-1.019v-4.75H181v6.839h-1.035l-.1-1.032h-.032c-.55.721-1.146 1.194-1.982 1.194-1.29 0-1.851-.957-1.851-2.699M183 41.205l.65-.898c.588.473 1.165.764 1.874.764.793 0 1.166-.388 1.166-.897 0-.607-.745-.875-1.466-1.154-.878-.339-1.888-.812-1.888-1.941 0-1.115.89-1.953 2.345-1.953.89 0 1.61.364 2.151.788l-.649.862c-.457-.34-.926-.583-1.478-.583-.722 0-1.058.365-1.058.826 0 .57.685.789 1.406 1.055.926.353 1.947.765 1.947 2.026 0 1.117-.877 2.026-2.512 2.026-.913 0-1.851-.387-2.488-.921M193.75 38.038c0-1.153-.543-1.82-1.554-1.82-.872 0-1.642.643-1.782 1.82h3.336zm-4.75.606c0-2.17 1.54-3.517 3.17-3.517 1.845 0 2.83 1.272 2.83 3.166 0 .267-.025.546-.063.704h-4.51c.114 1.273.948 2.038 2.148 2.038.619 0 1.15-.183 1.655-.497l.505.885c-.644.412-1.44.703-2.35.703-1.882 0-3.385-1.285-3.385-3.482zM197 39.428v-4.301h1.266v4.128c0 1.18.298 1.64 1.013 1.64.562 0 .948-.297 1.454-1.019v-4.75H202v6.839h-1.035l-.1-1.032h-.032c-.551.721-1.146 1.194-1.983 1.194-1.289 0-1.85-.957-1.85-2.699M204 35.3h1.09l.105.956h.035c.544-.622 1.183-1.13 1.97-1.13.952 0 1.486.472 1.764 1.254.626-.72 1.276-1.254 2.076-1.254 1.334 0 1.96.968 1.96 2.705v4.295h-1.334v-4.12c0-1.18-.347-1.652-1.067-1.652-.44 0-.905.31-1.438.932v4.84h-1.334v-4.12c0-1.18-.336-1.652-1.067-1.652-.428 0-.904.31-1.438.932v4.84H204V35.3z",
    transform: "translate(-360 -1349) translate(0 1305) translate(360 44)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a03766fc143906f48206f486ec6c3af1.svg";
export { ForwardRef as ReactComponent };